import React, { FC, ReactNode } from 'react';

import { SpaceProvider, useSpaces } from '@ably/spaces/react';
import { ChannelProvider, useChannel } from 'ably/react';

import { Team, WebSocketEvent } from 'models';

import { CreditService } from 'services/CreditService';
import { TeamService } from 'services/TeamService';

const Listeners: FC<{ teamId: string }> = ({ teamId }) => {
    useChannel(`team-${teamId}`, async (message) => {
        switch (message.name) {
            case WebSocketEvent.TEAM_CREDIT_BALANCE_CHANGED: {
                await TeamService.refresh(teamId);
                await CreditService.refreshCreditBalanceDetails(teamId);
                break;
            }
        }
    });

    return null;
};

const RealtimeTeamProvider: FC<{
    team: Team | null;
    children?: ReactNode;
}> = ({ team = null, children }) => {
    const spaces = useSpaces();

    return spaces && team ? (
        <SpaceProvider name={`team-${team.id}`} key={`team-${team.id}`} options={{ offlineTimeout: 5000 }}>
            <ChannelProvider channelName={`team-${team.id}`}>
                <Listeners teamId={team.id} />
                {children}
            </ChannelProvider>
        </SpaceProvider>
    ) : null;
};

export { RealtimeTeamProvider };
